import React from 'react';

const NotFound = () => {
    return (
        <div className="gmail-container">
            <div>
                <img src="/error.png" alt=""  className='img404'/>
            </div>
        </div>
    );
};

export default NotFound;